// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lzXEU","content":"styles_content__39kbA"};